import React, { useEffect, useState } from 'react';
import { Button, Col, Row, Tab, Tabs } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FiEdit } from "react-icons/fi";
import InfiniteScroll from 'react-infinite-scroll-component';

import { get_app_categories_data_by_category } from '../../../Controller/actions';

export const CategoryBox = ({ categoriesData }) => {
    const [currentCategory, setCurrentCategory] = useState(categoriesData[0]?.name);
    const [currentCategoryData, setCurrentCategoryData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(8);
    const navigate = useNavigate();

    const handleTabChange = async (e) => {
        const { status, message, data, page, totalPage } = await get_app_categories_data_by_category({ category: e?.target?.innerHTML ? e?.target?.innerHTML : currentCategory });
        // , page: currentPage, perPage
        if (status) {
            setCurrentCategoryData(data)
            setCurrentPage(page + 1);
        } else {
            console.log(message);
        }
    };

    useEffect(() => {
        handleTabChange();
    }, []);

    return (
        <>
            <Tabs
                id="uncontrolled-tab-example"
                className="my-1 preview-category flex-nowrap overflow-scroll"
                onClick={handleTabChange}
                defaultValue={currentCategory}
            >
                {
                    categoriesData && categoriesData.length && categoriesData?.length < 1 ?
                        <div className="d-flex justify-content-start align-items-center text-center">
                            No Data Found
                        </div>
                        : categoriesData?.map((_ele, i) => (
                            <Tab key={i} eventKey={_ele.name.toLowerCase()} title={_ele.name} ></Tab>
                        ))
                }
            </Tabs>

            <div className="category-tabs py-1">
                {/* <InfiniteScroll> */}
                <Row className="g-2 theme-main-div">
                    {currentCategoryData?.map((_ele, i) => (
                        <Col lg={6} xs={6} key={i}>
                            <div className="w-100 me-2 slider-card-edit-btn theme-preview-div position-relative">
                                <img
                                    className='w-100'
                                    src={_ele.bigPreview}
                                    alt=""
                                    style={{ borderRadius: "20px" }}
                                />
                                <Button variant='dark' className='slider-edit-btn p-1 position-absolute' onClick={() => navigate(`/sliderform`, { state: _ele })}>
                                    <FiEdit size={"20px"} />
                                </Button>
                            </div>
                        </Col>
                    ))}
                </Row>
                {/* </InfiniteScroll> */}
            </div>
        </>
    )
}

export default CategoryBox